module.exports = __webpack_public_path__ + "static/img/Deyuimg_03.33686863.png";